import { seCeCopy } from './seCe';

export const veeqoCopy = { ...seCeCopy };
